// IMPORTS
// Modules
import { useState, useEffect } from 'react';
// OHS
import { OHSAppHeader, OHSAppBody, OHSAppFooter } from '../../onehivesystems/js/OHSApp';
import OHSCRUD from '../../onehivesystems/js/OHSCRUD';
import OHSWidget from '../../onehivesystems/js/OHSWidget';
// Assets
import './ApplicationSettings.scss';


// COMPONENT
export default function ApplicationSettings (props) {
   // States and Variables
   const [settings, setSettings] = useState(null);

   // On-Load
   useEffect(function () {
      props.onehive.setOneHiveTitle("Application Settings"); // set page title
      getSettings();
   }, []);

   // Functions
   const getSettings = function () {
      OHSCRUD({
         url: '/v1/onehive/settings',
         method: 'GET',
         success: function (data) {
            setSettings(data);
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup
      });
   }
   function formatApplicationName (application) {
      return application.charAt(0).toUpperCase() + application.slice(1, 3) + application.charAt(3).toUpperCase() + application.slice(4);
   }

   // Component
   return (
      <div className="applicationsettings">
         <OHSAppHeader onehive={props.onehive} title="Application Settings" help="https://www.onehivesystems.com/documentation/applicationsettings" />
         <OHSAppBody onehive={props.onehive}>
            {settings && settings.length > 0 && settings.map(function (application, i) {
               return (
                  <OHSWidget onehive={props.onehive} key={`applicationsettings-application-${i}`} title={formatApplicationName(application.name)}>
                     <div className='applicationsettings-application'>
                        {application.settings && application.settings.length > 0 && application.settings.map(function (setting, j) {
                           return (
                              <div key={`applicationsettings-application-${i}-setting-${j}`} className='applicationsettings-application-setting'>
                                 <div className='applicationsettings-application-setting-name'>
                                    <p>{setting.name}</p>
                                 </div>
                                 <div className='applicationsettings-application-setting-value'>
                                    <p>{setting.value}</p>
                                 </div>
                              </div>
                           );
                        })}
                     </div>
                  </OHSWidget>
               );
            })}
         </OHSAppBody>
         <OHSAppFooter onehive={props.onehive} />
      </div>
   );
}